export const MAX_VISIBLE_DOTS = 7;

export const DOT_SIZE_REM = {
    ACTIVE: 0.8,
    NEIGHBOR: 0.6,
    INTERMEDIATE: 0.4,
    LAST: 0.2
} as const;

const MAX_SMALLEST_DOTS = 2;
const MAX_MEDIUM_DOTS_PER_SIDE = 1;

export interface IGalleryDotStyle {
    sizeRem: number;
    index: number;
    isActive: boolean;
}

export const getVisibleGalleryDotRange = (activeIndex: number, slidesCount: number): {start: number; end: number} => {
    if (slidesCount <= MAX_VISIBLE_DOTS) {
        return {start: 0, end: slidesCount};
    }

    const halfWindow = Math.floor(MAX_VISIBLE_DOTS / 2);
    let start = Math.max(0, activeIndex - halfWindow);
    let end = start + MAX_VISIBLE_DOTS;

    if (end > slidesCount) {
        end = slidesCount;
        start = end - MAX_VISIBLE_DOTS;
    }

    return {start, end};
};

/** Size falls off by distance from active: 6 / 4 / 2. */
const getInactiveDotSizeRem = (index: number, activeIndex: number): number => {
    const distance = Math.abs(index - activeIndex);

    if (distance === 1) return DOT_SIZE_REM.NEIGHBOR;
    if (distance === 2) return DOT_SIZE_REM.INTERMEDIATE;

    return DOT_SIZE_REM.LAST;
};

/** Near edges, distance falloff leaves >2 tiny dots — promote closest ones so at most 2 stay smallest. */
const limitSmallestDots = (dots: IGalleryDotStyle[], activeIndex: number): void => {
    const smallestIndexes = dots
        .filter((dot) => dot.sizeRem === DOT_SIZE_REM.LAST)
        .map((dot) => dot.index)
        .sort((a, b) => Math.abs(a - activeIndex) - Math.abs(b - activeIndex));

    const overflow = smallestIndexes.length - MAX_SMALLEST_DOTS;
    if (overflow <= 0) return;

    const promote = new Set(smallestIndexes.slice(0, overflow));

    for (const dot of dots) {
        if (promote.has(dot.index)) {
            dot.sizeRem = DOT_SIZE_REM.INTERMEDIATE;
        }
    }
};

/** At most one medium (0.4) per side of active; promote closer overflow to neighbor (0.6). */
const limitMediumDotsPerSide = (dots: IGalleryDotStyle[], activeIndex: number): void => {
    const limitSide = (isOnSide: (index: number) => boolean) => {
        const mediumIndexes = dots
            .filter((dot) => isOnSide(dot.index) && dot.sizeRem === DOT_SIZE_REM.INTERMEDIATE)
            .map((dot) => dot.index)
            .sort((a, b) => Math.abs(a - activeIndex) - Math.abs(b - activeIndex));

        const overflow = mediumIndexes.length - MAX_MEDIUM_DOTS_PER_SIDE;
        if (overflow <= 0) return;

        const promote = new Set(mediumIndexes.slice(0, overflow));

        for (const dot of dots) {
            if (promote.has(dot.index)) {
                dot.sizeRem = DOT_SIZE_REM.NEIGHBOR;
            }
        }
    };

    limitSide((index) => index < activeIndex);
    limitSide((index) => index > activeIndex);
};

export const getGalleryDotStyles = (activeIndex: number, slidesCount: number): IGalleryDotStyle[] => {
    if (slidesCount <= 1) return [];

    const {start, end} = getVisibleGalleryDotRange(activeIndex, slidesCount);
    const dots: IGalleryDotStyle[] = [];

    for (let index = start; index < end; index++) {
        const isActive = index === activeIndex;

        dots.push({
            sizeRem: isActive ? DOT_SIZE_REM.ACTIVE : getInactiveDotSizeRem(index, activeIndex),
            index,
            isActive
        });
    }

    limitSmallestDots(dots, activeIndex);
    limitMediumDotsPerSide(dots, activeIndex);

    return dots;
};
export const MAX_VISIBLE_DOTS = 7;

export const DOT_SIZE_REM = {
    ACTIVE: 0.8,
    NEIGHBOR: 0.6,
    INTERMEDIATE: 0.4,
    LAST: 0.2
} as const;

const MAX_SMALLEST_DOTS = 2;
const MAX_MEDIUM_DOTS_PER_SIDE = 1;

export interface IGalleryDotStyle {
    sizeRem: number;
    index: number;
    isActive: boolean;
}

export const getVisibleGalleryDotRange = (activeIndex: number, slidesCount: number): {start: number; end: number} => {
    if (slidesCount <= MAX_VISIBLE_DOTS) {
        return {start: 0, end: slidesCount};
    }

    const halfWindow = Math.floor(MAX_VISIBLE_DOTS / 2);
    let start = Math.max(0, activeIndex - halfWindow);
    let end = start + MAX_VISIBLE_DOTS;

    if (end > slidesCount) {
        end = slidesCount;
        start = end - MAX_VISIBLE_DOTS;
    }

    return {start, end};
};

/** Size falls off by distance from active: 6 / 4 / 2. */
const getInactiveDotSizeRem = (index: number, activeIndex: number): number => {
    const distance = Math.abs(index - activeIndex);

    if (distance === 1) return DOT_SIZE_REM.NEIGHBOR;
    if (distance === 2) return DOT_SIZE_REM.INTERMEDIATE;

    return DOT_SIZE_REM.LAST;
};

/** Near edges, distance falloff leaves >2 tiny dots — promote closest ones so at most 2 stay smallest. */
const limitSmallestDots = (dots: IGalleryDotStyle[], activeIndex: number): void => {
    const smallestIndexes = dots
        .filter((dot) => dot.sizeRem === DOT_SIZE_REM.LAST)
        .map((dot) => dot.index)
        .sort((a, b) => Math.abs(a - activeIndex) - Math.abs(b - activeIndex));

    const overflow = smallestIndexes.length - MAX_SMALLEST_DOTS;
    if (overflow <= 0) return;

    const promote = new Set(smallestIndexes.slice(0, overflow));

    for (const dot of dots) {
        if (promote.has(dot.index)) {
            dot.sizeRem = DOT_SIZE_REM.INTERMEDIATE;
        }
    }
};

/** At most one medium (0.4) per side of active; promote closer overflow to neighbor (0.6). */
const limitMediumDotsPerSide = (dots: IGalleryDotStyle[], activeIndex: number): void => {
    const limitSide = (isOnSide: (index: number) => boolean) => {
        const mediumIndexes = dots
            .filter((dot) => isOnSide(dot.index) && dot.sizeRem === DOT_SIZE_REM.INTERMEDIATE)
            .map((dot) => dot.index)
            .sort((a, b) => Math.abs(a - activeIndex) - Math.abs(b - activeIndex));

        const overflow = mediumIndexes.length - MAX_MEDIUM_DOTS_PER_SIDE;
        if (overflow <= 0) return;

        const promote = new Set(mediumIndexes.slice(0, overflow));

        for (const dot of dots) {
            if (promote.has(dot.index)) {
                dot.sizeRem = DOT_SIZE_REM.NEIGHBOR;
            }
        }
    };

    limitSide((index) => index < activeIndex);
    limitSide((index) => index > activeIndex);
};

export const getGalleryDotStyles = (activeIndex: number, slidesCount: number): IGalleryDotStyle[] => {
    if (slidesCount <= 1) return [];

    const {start, end} = getVisibleGalleryDotRange(activeIndex, slidesCount);
    const dots: IGalleryDotStyle[] = [];

    for (let index = start; index < end; index++) {
        const isActive = index === activeIndex;

        dots.push({
            sizeRem: isActive ? DOT_SIZE_REM.ACTIVE : getInactiveDotSizeRem(index, activeIndex),
            index,
            isActive
        });
    }

    limitSmallestDots(dots, activeIndex);
    limitMediumDotsPerSide(dots, activeIndex);

    return dots;
};
